module.exports = __webpack_public_path__ + "assets/33b36c9cd128e993e6854514a5b09bc9.mp3";